// extracted by mini-css-extract-plugin
export default {"container":"src-components-GlobalTooltip-GlobalTooltip__container--Yzlhj"};